import barba from '@barba/core';
import {defaultAnimationEnter, defaultAnimationLeave, defaultAnimationOnce} from "../animations/default";
import {app_initialisation, app_desinitialisation} from "../app/index";
import {credit as credit_init} from "../credits/credits";
import global_navigation_init from "../navigation"
import {update_current_navigation_hightlighted} from "../navigation/navigation_links"
import update_brand_markup from "../navigation/brand_markup";
import {transitions as barba_transition} from "./transitions";
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import php from 'highlight.js/lib/languages/php';
import css from 'highlight.js/lib/languages/css';
import scss from 'highlight.js/lib/languages/scss';
import xml from 'highlight.js/lib/languages/xml';
import twig from 'highlight.js/lib/languages/twig';

// Object pour l'itilisation de barba
const barba_config = {
    // Cache page
    cacheIgnore: false,

    // Disable barba on click on the WP admin-bar item, sur les liens qui ont la classe no-barba-link
    // et sur les liens des wp-caption (image insérée via l'éditeur wysiwyg)
    prevent: ({el}) => {
        const parentNode = el.parentNode;
        return (
            el.classList && (el.classList.contains('ab-item') || el.classList.contains('no-barba-link'))
            ||
            parentNode.classList && parentNode.classList.contains('wp-caption')
        )
    },

    // Prevent click during a transition
    preventRunning: true,

    // Non debug
    debug: false,
    logLevel: 'off', // off|error|warning|info|debug

    // Transitions :
    transitions: barba_transition
}

const register_highlight_language = () =>{
    hljs.registerLanguage('javascript', javascript);
    hljs.registerLanguage('php', php);
    hljs.registerLanguage('css', css);
    hljs.registerLanguage('scss', scss);
    hljs.registerLanguage('xml', xml);
    hljs.registerLanguage('twig', twig);
}

/**
 * Initialisation de barba
 */
const barba_initialisation = () => {
    barba.hooks.afterLeave(({current}) => {
         // console.log("Global AFTERLEAVE ==> Désinitialisation des comportements JS");

        // console.log("scroll top");
        window.scrollTo(0, 0);
        app_desinitialisation(current.container);
        current.container.remove()
    })
    barba.hooks.once(({next}) => {
        // console.log("Globak ONCE Hook ==> Initialisation des comportements JS (écouteur, etc...)");
        credit_init();
        global_navigation_init();
        register_highlight_language();
        app_initialisation(next.container);
    })
    barba.hooks.enter(({current, next}) => {
        // console.log("Globak ENTER Hook ==> Initialisation des comportements JS (écouteur, etc...)");
        update_brand_markup(next.url.path);
        update_current_navigation_hightlighted(current.namespace, next.namespace);
        app_initialisation(next.container);

        if(next.namespace !== "project_single"){
            const header = document.querySelector('#main-header');
            const yearCopy = document.querySelector('#year-copy');
            header.classList.remove('no-mix-blend');
            yearCopy.classList.remove('no-mix-blend');
        }
    })
    barba.init(barba_config);
}

export default barba_initialisation
